<template>
    <nav :aria-label="customAriaLabel">
        <ol class="breadcrumb" :class="isInverse ? 'ob1-breadcrumb-inverse' : ''" data-ob1-component="Breadcrumb">
            <li v-for="(item, index) in breadcrumbItems" :key="index" class="breadcrumb-item">
                <a :href="item.href">{{ item.label }}</a>
            </li>
            <li class="breadcrumb-item" aria-current="page">
                {{ label }}
            </li>
        </ol>
    </nav>
</template>

<script lang="ts">
import {defineComponent, type PropType} from 'vue';
import {BreadcrumbItem} from "./models/BreadcrumbItem";

export default defineComponent({
    name: 'Breadcrumb',
    props: {
        customAriaLabel: {
            type: String,
            required: true
        },
        isInverse: {
            type: Boolean,
            required: false,
            default: false
        },
        breadcrumbItems: {
            type: Array as PropType<Array<BreadcrumbItem>>,
            required: true
        },
        label: {
            type: String,
            required: true
        }
    }
});
</script>
